import {Lightbox} from "../classes/Lightbox.js";

export const initGetAjaxForm = () => {
	document.addEventListener(`click`, ( evt ) => {
		const button = evt.target.closest(`button.get-ajax-form`);
		const link = evt.target.closest(`a.get-ajax-form`);

		if ( button || link )
		{
			evt.preventDefault();
			
			const _this = button || link;
			
			_this.classList.add(`sending`);

			const data = JSON.parse( _this.getAttribute(`data-names`) );
			const formData = new FormData();

			
			for ( let key in data ) 
			{
				if (data.hasOwnProperty(key))
				{
					formData.append( key, data[key]);
				}
			}

			_this.disabled = true;
			
			fetch(_this.getAttribute(`data-action`), {
				method: `POST`,
				credentials: `same-origin`,
				headers: {
					"X-Requested-With": `XMLHttpRequest`,
				},
				body: formData,
			})
				.then((response) => response.json())
				.then((data) => {
					if (Lightbox.getLightbox())
					{
						Lightbox.getLightbox().classList.remove(...Lightbox._lightboxClasses);
						Lightbox.replaceContent(data.rendered);
					} else
					{
						Lightbox.open(data.rendered);
					}

					_this.disabled = false;
				})
				.catch((err) => {
					_this.disabled = false;
				});
		}
	});
};
